import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { MapboxCustomCoordinate } from '@vdi/walden-shared/modifiers/mapbox';
import type { IntlService } from 'ember-intl';
import type { Shipment, ShipmentStateEnum } from 'graphql-models';
import { SHIPMENT_STATE_TRANSLATIONS } from 'walden-fast/constants/state-translations';
import type { AppServicesWaldenBoxMapModel } from 'walden-fast/routes/app/services/walden-box/map';

export default class AppServicesWaldenBoxMapController extends Controller {
  declare model: AppServicesWaldenBoxMapModel;

  @service('intl') declare intlService: IntlService;

  @tracked search: string | undefined;
  @tracked selectedShipment: Shipment | undefined;
  @tracked showDetailPanel: boolean = false;

  queryParams = ['search'];

  stateLabel = (state: ShipmentStateEnum) => {
    return this.intlService.t(SHIPMENT_STATE_TRANSLATIONS[state]);
  };

  get shipments() {
    return this.model.lastSuccessful?.value || [];
  }

  get shipmentCoordinates() {
    return this.shipments
      .filter((s) => s.currentLocation)
      .map((shipment) => {
        return [
          shipment.currentLocation?.longitude,
          shipment.currentLocation?.latitude,
          shipment.id,
        ] as MapboxCustomCoordinate;
      });
  }

  @action
  onShowShipmentDetails(coordinate: MapboxCustomCoordinate) {
    const shipment = this.shipments.find((s) => s.id === coordinate[2]);

    if (shipment) {
      this.selectedShipment = shipment;
      this.showDetailPanel = true;
    }
  }

  @action
  onHideShipmentDetails() {
    this.selectedShipment = undefined;
    this.showDetailPanel = false;
  }
}
